import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { filterChange, popUpMessageChange, signaturesUserChange, signaturesFilterChange } from '../../actions/index';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';

import { _ } from '../../functions/translator.js';
import { showMessage } from '../../functions/popUpMessage.js';
import { groupUsersByCharge } from '../../functions/utils.js';

function ChargeSignaturesDropdown(props) {
    const [selectedUsers, setSelectedUsers] = useState([]);

    useEffect(() => {
        setSelectedUsers([]);
    }, [props.signaturesFilterHistoric]);

    const handleUserChange = (event) => {
        const positions = event.target.value;
        setSelectedUsers(positions);
        props.signaturesFilterChange(positions);

        const UsersByCharges = groupUsersByCharge(Object.values(props.projectUsers));
        const userIds = Object.entries(UsersByCharges)
            .filter(([clave]) => positions.includes(clave))
            .flatMap(([, valor]) => valor);
        props.signaturesUserChange(userIds);
        if (positions.length !== 0) {
            const message = _('Seleccione filtrar registros por') + ':';
            const messageConfig = {
                closeButton: true,
                signaturesFilterOption: true
            };
            showMessage(props, message, messageConfig);
        }
    };

    const useStyles = makeStyles((theme) => ({
        selected: {
            backgroundColor: '#3f51b5 !important',
            color: 'white',
        },
    }));
    const classes = useStyles();

    const UsersByCharges = groupUsersByCharge(Object.values(props.projectUsers));

    const chargesListMenuItems = Object.keys(UsersByCharges).map((charge) => (
        <MenuItem key={charge} value={charge}>
            <Checkbox color="primary" checked={selectedUsers.includes(charge)} />
            {charge}
        </MenuItem>
    ));

    return (
        <div>
            <Select
                value={selectedUsers}
                onChange={handleUserChange}
                multiple
                renderValue={(selected) => (
                    <div>
                        {selected.map(value => value).join(', ')}
                    </div>
                )}
                MenuProps={{
                    PaperProps: {
                        style: {
                          maxHeight: 300,
                          top: '0px',
                          position: 'fixed',
                        },
                    },
                    getContentAnchorEl: null,
                }}
            >
                {chargesListMenuItems}
            </Select>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        projectUsers: state.projectUsers,
        signaturesUserId: state.signaturesUserId,
        signaturesFilterHistoric: state.signaturesFilterHistoric,
    };
}

const mapDispatchToProps = {
    filterChange: filterChange,
    popUpMessageChange: popUpMessageChange,
    signaturesUserChange: signaturesUserChange,
    signaturesFilterChange: signaturesFilterChange,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChargeSignaturesDropdown);
